import './App.css';
import {HoraeDataGrande} from './DataEx.js'; 
import Navbar from './Menu';
import {  Routes, Route,  useLocation } from 'react-router-dom';
import BemVindo from './pag/BemVindo.js'; 
import Solucoes from './pag/Solucoes.js'; 
import Segmentos from './pag/Segmentos.js'; 
import Programas from './pag/Programas.js'; 
import Sobre from './pag/Sobre.js'; 
import Fale from './pag/Fale.js'; 
import Login from './login.js'; 
import LoginEsquceuSenha from './LoginEsquceuSenha.js'; 
import LoginSemCadastro from './LoginSemCadastro.js'; 
import Termos from './pag/termos.js';
import {Video1, Video2, Video3, Video4, Video5, Video6, Video7, Video8, Video9, Video10} from './pag/video.js'; 
import FormCli from './cliente/FormCli.js'; 
import FormCliente from './cliente/FormCliente.js'; 
import FormClienteNovo from './cliente/FormClienteNovo.js'; 
import FormClienteEquipamentos from './cliente/FormClienteEquipamentos.js'; 
import FormUsu from './usuario/FormUsu.js';
import FormUsuarioModulo from './usuario/FormUsuarioModulo.js';



import TpoGrid from './tabelas/tpo/Grid.js';
import ProGrid from './tabelas/pro/Grid.js';
import PagGrid from './tabelas/pag/Grid.js';
import AcrDesGrid from './tabelas/acrdes/Grid.js';
import FunGrid from './tabelas/fun/Grid.js';
import CcGrid from './tabelas/cc/Grid.js';
import PlaGrid from './tabelas/pla/Grid.js';
import AnuGrid from './tabelas/anu/Grid.js';
import FreGrid from './tabelas/fre/Grid.js';

import ProForm from './tabelas/pro/Form.js';
import PagForm from './tabelas/pag/Form.js';
import AcrDesForm from './tabelas/acrdes/Form.js';
import FunForm from './tabelas/fun/Form.js';
import CcForm from './tabelas/cc/Form.js';
import AnuForm from './tabelas/anu/Form.js';
import FreForm from './tabelas/fre/Form.js';
import PlaForm from './tabelas/pla/Form.js';
import TpoForm from './tabelas/tpo/Form.js';


import Pdv from './pdv/Form.js';


function App() {
  const location = useLocation(); 
  return (
  <div id="background">
    
    {location.pathname === "/" && <div class="DateeHora"><HoraeDataGrande/> </div>}
    {location.pathname === "/fale" && <div class="DateeHora"><HoraeDataGrande/> </div>}
    {location.pathname === "/sobre" && <div class="DateeHora"><HoraeDataGrande/> </div>}
    <div>
      <Navbar />
    </div>

        <Routes>
          <Route path="/" element={<BemVindo />} /> 
          <Route path="/Solucoes" element={<Solucoes />} />
          <Route path="/Segmentos" element={<Segmentos />} />
          <Route path="/Programas" element={<Programas />} />
          <Route path="/Sobre" element={<Sobre />} />
          <Route path="/Fale" element={<Fale />} />
          <Route path="/Area" element={<Login />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/FormCli" element={<FormCli /> } />
          <Route path="/FormCliente" element={<FormCliente /> } />
          <Route path="/FormClienteNovo" element={<FormClienteNovo /> } />
          <Route path="/FormClienteEquipamentos" element={<FormClienteEquipamentos /> } />
          <Route path="/FormUsu" element={<FormUsu /> } />
          <Route path="/video1" element={<Video1/> } />
          <Route path="/video2" element={<Video2/> } />
          <Route path="/video3" element={<Video3/> } />
          <Route path="/video4" element={<Video4/> } />
          <Route path="/video5" element={<Video5/> } />
          <Route path="/video6" element={<Video6/> } />
          <Route path="/video7" element={<Video7/> } />
          <Route path="/video8" element={<Video8/> } />
          <Route path="/video9" element={<Video9/> } />
          <Route path="/video10" element={<Video10/> } />
          <Route path="/LoginEsquceuSenha" element={<LoginEsquceuSenha/> } />
          <Route path="/LoginSemCadastro" element={<LoginSemCadastro/> } />
          
          <Route path="/TpoGrid" element={<TpoGrid/> } />
          <Route path="/TpoForm" element={<TpoForm/> } />
          <Route path="/ProGrid" element={<ProGrid/> } />
          <Route path="/ProForm" element={<ProForm/> } />
          <Route path="/PagGrid" element={<PagGrid/> } />
          <Route path="/PagForm" element={<PagForm/> } />
          <Route path="/AcrDesGrid" element={<AcrDesGrid/> } />
          <Route path="/AcrDesForm" element={<AcrDesForm/> } />
          <Route path="/FunGrid" element={<FunGrid/> } />
          <Route path="/FunForm" element={<FunForm/> } />
          <Route path="/CcGrid" element={<CcGrid/> } />
          <Route path="/CcForm" element={<CcForm/> } />
          <Route path="/PlaGrid" element={<PlaGrid/> } />
          <Route path="/PlaForm" element={<PlaForm/> } />
          <Route path="/FreGrid" element={<FreGrid/> } />
          <Route path="/FreForm" element={<FreForm/> } />
          <Route path="/AnuGrid" element={<AnuGrid/> } />
          <Route path="/AnuForm" element={<AnuForm/> } />
          <Route path="/Pdv" element={<Pdv/> } />
          <Route path="/FormUsuarioModulo" element={<FormUsuarioModulo/> } />
          <Route path="*" element={<><h2>Não Achei a pagina....</h2></> } />
        </Routes>
  </div>
  );
}

export default App;
